
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';

import { ViewType, OrderServiceStage } from '@/types/orderServicer';

@Component({
  name: 'orderServicerGrab',
  components: {
    OrderList,
    OrderSearch
  }
})
export default class extends Vue {
  private status = OrderServiceStage.SERVICE_STATUS_GRAB;
  private vt = ViewType.ORDER_SERVICER_GRAB;
}
